module.exports = __webpack_public_path__ + "img/product_example.e4046ebe.jpg";